/**
 * BCO Barrierefreiheit
 * Button unten in der Ecke + Panel mit Anzeige-Einstellungen.
 *
 * Markup: snippets/bco-a11y.liquid | Styles: assets/bco-a11y.css
 * Die Einstellungen liegen als data-a11y-* Attribute am <html> und werden
 * im localStorage unter "bco_a11y" gespeichert (nur Werte, die vom Standard
 * abweichen). snippets/bco-a11y-head.liquid setzt sie schon vor dem ersten
 * Rendern, damit nichts flackert.
 *
 * Von außen nutzbar:
 *   window.bcoA11y.open() / .close() / .reset()
 *   <button type="button" data-a11y-open>…</button> öffnet das Panel,
 *   z. B. auf der Seite "Erklärung zur Barrierefreiheit".
 */
(function () {
  'use strict';

  var KEY = 'bco_a11y';
  var DEFAULTS = { text: 'md', contrast: 'off', readable: 'off', links: 'off', motion: 'off', focus: 'off' };
  var VALID = {
    text: ['md', 'lg', 'xl'],
    contrast: ['off', 'high'],
    readable: ['off', 'on'],
    links: ['off', 'on'],
    motion: ['off', 'reduce'],
    focus: ['off', 'on']
  };
  var KEYS = Object.keys(DEFAULTS);

  var root = document.documentElement;
  var wrap = document.getElementById('bco-a11y');
  if (!wrap || wrap.dataset.bound) return;
  wrap.dataset.bound = '1';

  var btn = wrap.querySelector('.bco-a11y__btn');
  var dialog = wrap.querySelector('.bco-a11y__dialog');
  var title = wrap.querySelector('.bco-a11y__title');
  var closeBtn = wrap.querySelector('.bco-a11y__close');
  var resetBtn = wrap.querySelector('.bco-a11y__reset');
  var status = wrap.querySelector('.bco-a11y__status');
  if (!btn || !dialog) return;
  var nativeDialog = typeof dialog.showModal === 'function';

  /* ─── Zustand ─────────────────────────────────────────────────────── */
  function isValid(key, value) {
    return typeof value === 'string' && VALID[key].indexOf(value) !== -1;
  }

  function load() {
    var stored = null;
    try { stored = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) {}
    if (!stored || typeof stored !== 'object') stored = {};
    var result = {};
    KEYS.forEach(function (key) {
      result[key] = isValid(key, stored[key]) ? stored[key] : DEFAULTS[key];
    });
    return result;
  }

  function persist(current) {
    var diff = {};
    var any = false;
    KEYS.forEach(function (key) {
      if (current[key] !== DEFAULTS[key]) { diff[key] = current[key]; any = true; }
    });
    try {
      if (any) localStorage.setItem(KEY, JSON.stringify(diff));
      else localStorage.removeItem(KEY);
    } catch (e) {}
  }

  function syncControls(current) {
    var radios = wrap.querySelectorAll('input[name="bco-a11y-text"]');
    for (var i = 0; i < radios.length; i++) radios[i].checked = radios[i].value === current.text;
    var switches = wrap.querySelectorAll('input[data-a11y]');
    for (var j = 0; j < switches.length; j++) {
      var key = switches[j].getAttribute('data-a11y');
      switches[j].checked = current[key] === switches[j].getAttribute('data-on');
    }
  }

  function apply(current) {
    KEYS.forEach(function (key) {
      if (current[key] === DEFAULTS[key]) root.removeAttribute('data-a11y-' + key);
      else root.setAttribute('data-a11y-' + key, current[key]);
    });
    syncControls(current);
    handleMotion(current.motion === 'reduce');
  }

  var state = load();

  function set(key, value) {
    if (!isValid(key, value) || state[key] === value) return;
    state[key] = value;
    apply(state);
    persist(state);
    if (key === 'text') window.dispatchEvent(new Event('resize')); // Header-Höhe & Co. neu berechnen
  }

  function reset() {
    KEYS.forEach(function (key) { state[key] = DEFAULTS[key]; });
    apply(state);
    persist(state);
    window.dispatchEvent(new Event('resize'));
    announce('Alle Einstellungen zurückgesetzt.');
  }

  function announce(text) {
    if (!status) return;
    status.textContent = '';
    window.setTimeout(function () { status.textContent = text; }, 50);
  }

  /* ─── Animationen: Slideshows und Autoplay-Videos anhalten ────────── */
  var motionObserver = null;
  var motionTimer = null;

  function handleMotion(reduce) {
    var slides = document.querySelectorAll('slideshow-component[autoplay]');
    for (var i = 0; i < slides.length; i++) {
      var s = slides[i];
      try {
        if (reduce) {
          if (!s.hasAttribute('paused') && typeof s.pause === 'function') {
            s.pause();
            s.setAttribute('data-a11y-paused', '');
          }
        } else if (s.hasAttribute('data-a11y-paused')) {
          s.removeAttribute('data-a11y-paused');
          s.removeAttribute('paused');
          if (typeof s.play === 'function') s.play();
        }
      } catch (e) {}
    }

    var videos = document.querySelectorAll('video[autoplay]');
    for (var j = 0; j < videos.length; j++) {
      var v = videos[j];
      try {
        if (reduce) {
          if (!v.paused) { v.pause(); v.setAttribute('data-a11y-paused', ''); }
        } else if (v.hasAttribute('data-a11y-paused')) {
          v.removeAttribute('data-a11y-paused');
          var p = v.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        }
      } catch (e) {}
    }

    // Nachgeladene Abschnitte (Warenkorb, Filter, Editor …) ebenfalls anhalten
    if (reduce && !motionObserver && 'MutationObserver' in window) {
      motionObserver = new MutationObserver(function () {
        window.clearTimeout(motionTimer);
        motionTimer = window.setTimeout(function () {
          if (state.motion === 'reduce') handleMotion(true);
        }, 300);
      });
      motionObserver.observe(document.body, { childList: true, subtree: true });
    } else if (!reduce && motionObserver) {
      motionObserver.disconnect();
      motionObserver = null;
    }
  }

  /* ─── Dialog öffnen / schließen ───────────────────────────────────── */
  var closing = false;

  function isOpen() { return dialog.hasAttribute('open'); }

  function hasTransition() {
    var durations = (window.getComputedStyle(dialog).transitionDuration || '0s').split(',');
    for (var i = 0; i < durations.length; i++) {
      if (parseFloat(durations[i]) > 0.01) return true;
    }
    return false;
  }

  function open() {
    if (isOpen()) return;
    syncControls(state);
    if (nativeDialog) {
      try { dialog.showModal(); } catch (e) { dialog.setAttribute('open', ''); }
    } else {
      dialog.setAttribute('open', '');
      document.addEventListener('keydown', onKeydownFallback);
    }
    btn.setAttribute('aria-expanded', 'true');
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () { dialog.classList.add('is-open'); });
    });
    if (title) title.focus({ preventScroll: true });
  }

  function close() {
    if (!isOpen() || closing) return;
    closing = true;
    dialog.classList.remove('is-open');
    btn.setAttribute('aria-expanded', 'false');

    var done = false;
    var timer = null;
    function finish() {
      if (done) return;
      done = true;
      closing = false;
      window.clearTimeout(timer);
      dialog.removeEventListener('transitionend', onEnd);
      if (nativeDialog) {
        if (dialog.open) dialog.close();
      } else {
        dialog.removeAttribute('open');
        document.removeEventListener('keydown', onKeydownFallback);
      }
      btn.focus({ preventScroll: true });
    }
    function onEnd(e) { if (e.target === dialog) finish(); }

    if (!hasTransition()) { finish(); return; }
    dialog.addEventListener('transitionend', onEnd);
    timer = window.setTimeout(finish, 520);
  }

  function onKeydownFallback(e) { if (e.key === 'Escape') close(); }

  /* ─── Events ──────────────────────────────────────────────────────── */
  btn.addEventListener('click', function () { if (isOpen()) close(); else open(); });
  if (closeBtn) closeBtn.addEventListener('click', close);
  if (resetBtn) resetBtn.addEventListener('click', reset);

  dialog.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
  dialog.addEventListener('close', function () {
    // z. B. zweites Escape in Chrome, das sich nicht abfangen lässt
    dialog.classList.remove('is-open');
    btn.setAttribute('aria-expanded', 'false');
    closing = false;
  });
  dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });

  wrap.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.tagName !== 'INPUT') return;
    if (t.name === 'bco-a11y-text') {
      if (t.checked) set('text', t.value);
      return;
    }
    var key = t.getAttribute('data-a11y');
    if (key) set(key, t.checked ? t.getAttribute('data-on') : DEFAULTS[key]);
  });

  // Öffnen von anderen Stellen aus, z. B. Seite "Erklärung zur Barrierefreiheit"
  document.addEventListener('click', function (e) {
    var trigger = e.target && e.target.closest ? e.target.closest('[data-a11y-open]') : null;
    if (!trigger) return;
    e.preventDefault();
    open();
  });

  document.addEventListener('shopify:section:load', function () {
    if (state.motion === 'reduce') handleMotion(true);
  });

  window.bcoA11y = {
    open: open,
    close: close,
    reset: reset,
    get: function () { var copy = {}; KEYS.forEach(function (k) { copy[k] = state[k]; }); return copy; }
  };

  apply(state);
})();
